var map = {
	"./_agrocorp/en.json": "2f0f",
	"./_agrocorp/pt.json": "6699",
	"./_ajx/en.json": "efd4",
	"./_ajx/pt.json": "4418",
	"./_caishen/en.json": "2e03",
	"./_caishen/pt.json": "4e4a",
	"./_custoreal/en.json": "fe0d",
	"./_custoreal/pt.json": "f69d",
	"./_default/en.json": "403f",
	"./_default/pt.json": "e4b0",
	"./_dp/en.json": "6acf",
	"./_dp/pt.json": "8b5f",
	"./_equity-dsv/en.json": "af16",
	"./_equity-dsv/pt.json": "ac13",
	"./_finapop/en.json": "e7c6",
	"./_finapop/pt.json": "f4c3",
	"./_mcf/en.json": "39b1",
	"./_mcf/pt.json": "df16",
	"./_monefy/en.json": "9fc8",
	"./_monefy/pt.json": "6df6",
	"./_mypart/en.json": "49de",
	"./_mypart/pt.json": "b182",
	"./_p1-demo/en.json": "7009",
	"./_p1-demo/pt.json": "1bb0",
	"./_p2/en.json": "cbd8",
	"./_p2/pt.json": "ba90",
	"./_p3-demo/en.json": "9c9d",
	"./_p3-demo/pt.json": "f4e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";